const { Core, Utils, Events } = Global;
const { $loading } = Utils;

customElements.define('cart-drawer', class extends Core {
    elements = {
        'modal': 'modal-container'
    }

    render() {
        this.sub(Events.CART_UPDATE, this._handleAddingToCart, { global: true });
        this.sub(Events.CART_CHANGE, this._handleCartChange, { global: true });
        this.sub(Events.CART_REPLACE, this._handleCartChange, { global: true });
        this.sub(Events.CART_DRAWER_MUTE, this._handleMute, { once: true, global: true });
        this.sub(Events.CART_ERROR, this._handleCartError, { global: true });
    }

    _handleAddingToCart({ req }) {
        if (req === 'cartAdd') {
            // Create toast element
            const toast = document.createElement('div');
            toast.innerText = 'ITEM ADDED TO CART';
            toast.style.cssText = `
                position: fixed; /* Use fixed positioning to keep it on top */
                top: 10px;
                right: 16px;
                background: #ff0000;
                color: #fff;
                padding: 8px 14px;
                border-radius: 6px;
                box-shadow: 0 4px 10px rgba(0,0,0,0.2);
                font-size: 14px;
                font-weight: bold;
                z-index: 2147483647; /* Very high z-index to ensure it's above everything */
                opacity: 1;
                transition: opacity 0.3s ease;
                pointer-events: none;
            `;

            // Append the toast directly to the body, outside of any modal
            // document.body.appendChild(toast); //

           // Check if the quick view modal header exists
            const modalHeader = document.querySelector('#variant-selector-modal');

            if (modalHeader) {
                // Append toast inside the modal header to avoid backdrop blur
                modalHeader.appendChild(toast);
            } else {
                // Fallback to the body (outside the modal) if no modal header exists
                document.body.appendChild(toast);
            }

            // Fade out after 3 seconds
            setTimeout(() => {
                toast.style.opacity = '0';
                setTimeout(() => toast.remove(), 300);
            }, 3500);
        }
    }

    _handleCartChange({ key }) {
        this.updatingProduct = this.querySelector(`[data-item-key="${key}"]`);
        if (!this.updatingProduct) return;

        $loading(this.updatingProduct);
    }

    _handleMute() {
        this.unsub(Events.CART_UPDATE);
    }

    _handleCartError() {
        if (this.updatingProduct) {
            $loading(this.updatingProduct, false);
        }
    }
});
